export const blockIconsCommonactionsVerifiedNew = (
	<span className='material-symbols-outlined'>verified</span>
);
